export class PreferencesUtilisateurDto {
	zoneDeTravailParDefautId?: number;
	afficherWeekend: boolean;

	constructor(afficherWeekend: boolean, zoneDeTravailParDefautId?: number) {
		this.zoneDeTravailParDefautId = zoneDeTravailParDefautId;
		this.afficherWeekend = afficherWeekend;
	}
}
